<div
  class="container d-flex justify-content-center align-items-center min-vh-100"
>
  <div class="card shadow-sm p-4" style="width: 100%; max-width: 400px">
    <h3 class="mb-3 text-center">Reset Password</h3>
    <form (ngSubmit)="onSubmit()" [formGroup]="resetForm" novalidate>
      <!-- Email Field -->
      <div class="mb-3">
        <label for="email" class="form-label">Email address</label>
        <input
          type="email"
          id="email"
          class="form-control"
          formControlName="email"
          placeholder="Enter your email"
          [ngClass]="{ 'is-invalid': submitted && f['email'].errors }"
        />
        <div
          class="invalid-feedback"
          *ngIf="submitted && f['email'].errors?.['required']"
        >
          Email is required
        </div>
        <div
          class="invalid-feedback"
          *ngIf="submitted && f['email'].errors?.['email']"
        >
          Invalid email format
        </div>
      </div>

      <!-- New Password Field -->
      <div class="mb-3 position-relative">
        <label for="newPassword" class="form-label">New Password</label>
        <input
          [type]="passwordVisible ? 'text' : 'password'"
          id="newPassword"
          class="form-control"
          formControlName="newPassword"
          placeholder="Enter new password"
          [ngClass]="{ 'is-invalid': submitted && f['newPassword'].errors }"
        />
        <div
          class="invalid-feedback"
          *ngIf="submitted && f['newPassword'].errors?.['required']"
        >
          New password is required
        </div>
        <div
          class="invalid-feedback"
          *ngIf="submitted && f['newPassword'].errors?.['minlength']"
        >
          Password must be at least 8 characters
        </div>

        <!-- Eye icon to toggle password visibility -->
        <i
          class="bi bi-eye position-absolute"
          style="top: 50%; right: 10px; cursor: pointer"
          (click)="togglePasswordVisibility()"
        ></i>
      </div>

      <!-- Confirm Password Field -->
      <div class="mb-3 position-relative">
        <label for="confirmPassword" class="form-label">Confirm Password</label>
        <input
          [type]="passwordVisible ? 'text' : 'password'"
          id="confirmPassword"
          class="form-control"
          formControlName="confirmPassword"
          placeholder="Confirm your password"
          [ngClass]="{
            'is-invalid':
              (submitted && f['confirmPassword'].errors) || passwordMismatch
          }"
        />
        <div
          class="invalid-feedback"
          *ngIf="submitted && f['confirmPassword'].errors?.['required']"
        >
          Confirm password is required
        </div>
        <div class="invalid-feedback" *ngIf="passwordMismatch">
          Passwords must match
        </div>

        <!-- Eye icon to toggle password visibility -->
        <i
          class="bi bi-eye position-absolute"
          style="top: 50%; right: 10px; cursor: pointer"
          (click)="togglePasswordVisibility()"
        ></i>
      </div>

      <!-- Submit Button -->
      <button type="submit" class="btn btn-primary w-100">
        Reset Password
      </button>
    </form>

    <!-- Link to Login -->
    <div class="text-center mt-3">
      <a routerLink="/login" class="text-decoration-none">Back to Login</a>
    </div>
  </div>
</div>
